// Module
var code = "<p>export default &quot;This is going to be a text document.\\n\\nI am going to see if I can get this formatted like this.\\nBut we shall see how that turns out.\\n&quot;;</p> ";
// Exports
module.exports = code;